import { createSelector } from '@reduxjs/toolkit';

const selectFutureActionsState = state => state.futureactions;

export const selectFutureActions = createSelector(
  [selectFutureActionsState],
  futureActions => futureActions.data,
);

export const selectFutureActionsLoading = createSelector(
  [selectFutureActionsState],
  futureActions => futureActions.loading,
);

export const selectFutureActionsError = createSelector(
  [selectFutureActionsState],
  futureActions => futureActions.error,
);

export const selectFutureActionsFilters = createSelector(
  [selectFutureActionsState],
  futureActions => futureActions.filters,
);

export const selectFilteredFutureActions = createSelector(
  [selectFutureActions, selectFutureActionsFilters],
  (futureActions, filters) => {
    let filtered = futureActions;

    if (filters.searchText) {
      const searchLower = filters.searchText.toLowerCase();
      filtered = filtered.filter(
        futureAction =>
          futureAction.toolID?.toLowerCase().includes(searchLower) ||
          futureAction.customerName?.toLowerCase().includes(searchLower) ||
          futureAction.moldNumber?.toLowerCase().includes(searchLower) ||
          futureAction.moldDescription?.toLowerCase().includes(searchLower),
      );
    }

    if (filters.fromDate && filters.toDate) {
      filtered = filtered.filter(futureAction => {
        const futureActionDate = new Date(futureAction.receivedDate);
        return futureActionDate >= filters.fromDate && futureActionDate <= filters.toDate;
      });
    }

    if (filters.isReleased !== 0) {
      filtered = filtered.filter(futureAction => futureAction.isReleased === filters.isReleased);
    }

    return filtered;
  },
);

export const selectTileView = createSelector(
  [selectFutureActionsState],
  futureActions => futureActions.tileView,
);

export const selectFutureActionsFilterVisible = createSelector(
  [selectFutureActionsState],
  futureActions => futureActions.filterVisible,
);

export const selectfetchFutureActionsLoading = createSelector(
  [selectFutureActionsState],
  futureActions => futureActions.futureActionsLoading,
);
